import { lazy } from "react";
import Loadable from "../../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../../router/AuthorizedRoute";

const MyCommissonReports = Loadable(
  lazy(() =>
    import("./MyCommissionReportsList").then(({ MyCommissionReportsList }) => ({
      default: MyCommissionReportsList,
    }))
  )
);

export const myCommissionReportsRoutes = [
  {
    path: `/my-commission-reports`,
    exact: true,
    element: (
      <AuthorizedRoute allowFullAccess moduleKeys={[]}>
        <MyCommissonReports />
      </AuthorizedRoute>
    ),
  },
];
